import React from 'react';
import classNames from 'classnames';
import { AssetWrapper } from '../AssetWrapper';
import { Image } from '../Image';
import styles from './VideoThumbnail.module.scss';

interface VideoThumbnailProps {
	imageUrl: string;
	thumbnailAlternativeText?: string;
	isSmall?: boolean;
	aspectRatio?: string;
}

/**
 * Generic VideoThumbnail component, displays a still image from a video with a play icon
 */
export const VideoThumbnail: React.FunctionComponent<VideoThumbnailProps> = ({
	imageUrl,
	thumbnailAlternativeText,
	isSmall,
	aspectRatio,
}) => {
	return (
		<div className={styles.wrapper}>
			<AssetWrapper fixedRatio aspectRatio={aspectRatio}>
				<div>
					<Image
						className={styles.image}
						size180={{ url: imageUrl }}
						altText={thumbnailAlternativeText || ''}
					/>
					<span className={classNames(styles.playIcon, { [styles.isSmall]: isSmall })} />
				</div>
			</AssetWrapper>
		</div>
	);
};
